import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ExecutionObjectivesCompleteValidationSchema } from '../../../schemas/forwardings/executionObjectives/executionObjectivesComplete.schema';

interface UseCompleteMaintenanceExeuctionObjectiveProps {
  objectiveId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    ExecutionObjectivesCompleteValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useCompleteMaintenanceExecutionObjective = ({
  objectiveId,
  options,
}: UseCompleteMaintenanceExeuctionObjectiveProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['completeMaintenanceExeuctionObjective'],
    mutationFn: (form) => {
      const payload = {
        photos_attachments_attributes: form.photos_attachments_attributes?.map((photo) => ({
          blob_id: photo.id,
        })),
      }

      return privateAxios.put(`/maintenance/execution_objectives/${objectiveId}/complete`, payload);
    },
    ...options
  });
}
